import styled from 'styled-components';

export const CustomFieldsDrawerStyles = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	height: 100%;

	.actions {
		margin-top: auto;
		padding-top: 1rem;
	}
`;
